import v3Generic from './v3-generic';
var _v3Generic = v3Generic('reactions'),
  create = _v3Generic.create,
  update = _v3Generic.update,
  getAll = _v3Generic.getAll;
export default {
  create: create,
  update: update,
  getAll: getAll
};